import { MoiCommentModel } from "@app/moi/shared/moi-comment-model";

export class MoiWorkflowUpdateModel {
    approved: boolean;
    comment: MoiCommentModel;
}